import React, { Component } from 'react';
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import ConsultationForm from './FConsultationForm';
import $ from "jquery";
class ConsultationApp extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $('#menu_free_consultation').addClass('hide_im');
}


  render() {
    return (
        <div className="container-xxl bg-white p-0">
          <Spinner/>
          <TopMenu title="Free Consultation"/>
          <ConsultationForm/>
          <Footer />
        </div>
    );
  }
}

export default ConsultationApp;
